import React from 'react';
import RequiredField from '../Constraints/RequiredField';
import { FieldEditTabProps } from '../../types';
import { observer } from 'mobx-react';
import { CloudinaryVideoConstraints } from '../../FieldSerializer/fields/cloudinary-video';
import { requiredMappedErrors } from '../../../../services/FormUtils/DefinitionFieldMappedErrors';

function TransformableVideoConstraints(props: FieldEditTabProps<CloudinaryVideoConstraints>) {
    if (props.isArrayChildren) {
        return null;
    }
    return (
        <RequiredField
            relatedTabKey={'validationTab'}
            mappedErrors={requiredMappedErrors}
            onChange={required => props.onChangeConstraint('required', required)}
            value={props.constraints.required}
        />
    );
}

export default observer(TransformableVideoConstraints);
